import React from 'react';

import GeneralCustomAlert from './Alert';
import BusinessNetwork from './BusinessNetwork';
import DocumentProfile from './DocumentProfile';
import EntityRecord from './EntityRecord';
import PurchaseOrderModals from './PurchaseOrderModals';
import TenderModal from './TenderModal';

const GeneralComponents = () => {
  return (
    <>
      <GeneralCustomAlert />
      <BusinessNetwork />
      <TenderModal />
      <PurchaseOrderModals />
      <DocumentProfile />
      <EntityRecord />
    </>
  );
};

export default GeneralComponents;
